<template>
  <component :is="messageData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="messageData === undefined">
      <h4 class="alert-heading">獲取商品數據時出錯</h4>
      <div class="alert-body">
        找不到相關商品記錄。請查看
        <b-link class="alert-link" :to="{ name: 'messages-list' }">
          商品名單
        </b-link>
      </div>
    </b-alert>

    <message-edit-tab-information
      v-if="messageData"
      :user-type-options="userTypeOptions"
      :user-options="userOptions"
      :project-options="projectOptions"
      :quotation-options="quotationOptions"
      :invoice-options="invoiceOptions"
      :receipt-options="receiptOptions"
      :message-document-type-options="messageDocumentTypeOptions"
      :message-data="messageData"
      :loading="loading"
      class="p-sm-2"
    />

    <!-- @refetch-data="refetchData" -->
  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import messageStoreModule from "../messageStoreModule";
import MessageEditTabInformation from "./messageEditTabInformation.vue";

export default {
  components: {
    MessageEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {
    const messageData = ref({id: 0});
    const message = {
      id: 0,
      message_document_type_id:1,
      document_type_id: null,
      project_id: null,
      invoice_id: null,
      receipt_id: null,
      quotation_id: null,
      user_ids: [],
      user_type_id: null,
      is_group: 0,
    };

    const message_APP_STORE_MODULE_NAME = "message";

    if (!store.hasModule(message_APP_STORE_MODULE_NAME))
      store.registerModule(message_APP_STORE_MODULE_NAME, messageStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(message_APP_STORE_MODULE_NAME))
        store.unregisterModule(message_APP_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      
      if (router.currentRoute.name == "message-create") {
        messageData.value = message;
      } else {
       
        store
          .dispatch("message/fetchMessage", { id: router.currentRoute.params.id })
          .then((response) => {
            messageData.value = response.data.message;
            console.log(messageData.value)
          })
          .catch((error) => {
            console.log("error when fetching message", error);
            if (error.response.status === 404) {
              messageData.value = undefined;
            }
          });
      }
    };

    const loading = ref(false);

    const userTypeOptions = ref([]);
    const userOptions = ref([]);
    const projectOptions = ref([]);
    const quotationOptions = ref([]);
    const invoiceOptions = ref([]);
    const receiptOptions = ref([]);
    const messageDocumentTypeOptions = ref([]);

    const refetchOption = () => {
      loading.value = true;
      store
        .dispatch("app/fetchOptionList", {
          user_types: true,
          all_users: true,
          projects: true,
          quotations: true,
          invoices: true,
          receipts: true,
          message_document_types: true,
        })
        .then((response) => {
          userTypeOptions.value = response.data.user_types;
          userOptions.value = response.data.users;
          projectOptions.value = response.data.projects;
          quotationOptions.value = response.data.quotations;
          invoiceOptions.value = response.data.invoices;
          receiptOptions.value = response.data.receipts;
          messageDocumentTypeOptions.value = response.data.message_document_types || [];
          loading.value = false;
        });
    };


    onMounted(() => {
      refetchOption();
      refetchData();
    });

    return {
      messageData,
      userTypeOptions,
      userOptions,
      projectOptions,
      quotationOptions,
      invoiceOptions,
      receiptOptions,
      messageDocumentTypeOptions,
      refetchOption,
      loading
    };
  },
};
</script>
